import { z } from "zod";

export const AssignMaterialFormSchema = z.object({
  materials: z
    .array(
      z.object({
        id: z.number(),
        name: z.string(),
      }),
    )
    .min(1, { message: "Selecciona al menos un material." })
    .default([]),
});

export type AssignMaterialFormValues = z.infer<typeof AssignMaterialFormSchema>;
